import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectEmpleadorUser } from 'app/store/selectors/empleador.selectors';
import { firstValueFrom } from 'rxjs';

export const employerRedirectGuard: CanActivateFn = async () => {
    const router = inject(Router);
    const store = inject(Store);

    const empleador = await firstValueFrom(
        store.select(selectEmpleadorUser)
    );

    const estadoFocun =
        empleador?.estados_empleador?.estado_configuracion_focun;
    const estadoOnboarding =
        empleador?.estados_empleador?.estado_onboarding;


    if (estadoFocun !== 2 && estadoOnboarding !== 5) {
        router.navigate(['/ans/empresas'], {
            queryParams: { isAdmin: false }
        });
        return false;
    }

    return true;
};
